import React, { useEffect, useState } from "react";
import { Col, Form, ProgressBar, Row, Spinner } from "react-bootstrap";
import { FaCircleXmark } from "react-icons/fa6";
import { Button, Input } from "../CustomComponents";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import _ from "lodash";
import Toast, { SuccessToast } from "../../Hooks/useToast";
import {
  useAddServiceMutation,
  useUpdateServiceMutation,
} from "../../Data/services/serviceApi";
import { Controller, useForm } from "react-hook-form";
import DetailRow from "../CustomComponents/DetailRow";
import { GAME_TYPE } from "../../constants";
import UserAvatar from "../CustomComponents/UserAvatar";

const DetailGameCategoryModal = ({ handleEditModalClose, editData }) => {
  console.log(editData);

  const [mounted, setMounted] = React.useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return;
  }

  return (
    <div>
      <ModalContainer handleClose={handleEditModalClose}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0 text-black">More Details</p>
            <span className="bg-dark bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleEditModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <div className="w-100">
            <Row className="text-black g-5">
              <Col sm={12} md={12}>
                <DetailRow
                  title={"Game Name En"}
                  value={editData.category.name.en}
                />

                <DetailRow
                  title={"Game Name Ar"}
                  value={editData.category.name.ar}
                />

                <DetailRow
                  title={"Completed"}
                  value={editData.is_completed ? "Yes" : "No"}
                />
              </Col>
            </Row>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default DetailGameCategoryModal;
